import React, { useEffect, useRef, useState } from "react";
import { Box, Card, Container, Grid, Stack, Typography } from "@mui/material";
import styles from "./index.module.css";
import { ASSETS } from "../../../utils/config";
import { parseAVHtmlData } from "../../../utils/helpers";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import IconMenu from "@components/IconMenu";
import ImagePreviewModal from "@components/ImagePreviewModal";
import RichTextEditorViewWheel from "../../../components/Editor/children/RichTextEditorViewWheel";
import { TextView } from "@components";

const CardContent = ({
  content,
  color = "white",
  onCardClose = () => {},
  onEditClick = () => {},
  wheelId,
  showEditIcon,
  position,
  onPin = () => {},
  onUnPin = () => {},
}) => {
  var nav = useNavigate();

  const [showMenu, setShowMenu] = useState(false);

  function useOutsideClick(menuRef, iconMenuRef, callback) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (
          menuRef.current &&
          !menuRef.current.contains(event.target) &&
          (!iconMenuRef.current || !iconMenuRef.current.contains(event.target))
        ) {
          callback();
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [menuRef, iconMenuRef, callback]);
  }

  const menuRef = useRef();
  const iconMenuRef = useRef(); // Ref for the IconMenu

  // Use the custom hook
  useOutsideClick(menuRef, iconMenuRef, () => {
    if (showMenu) setShowMenu(false);
  });

  if (!content) {
    return null;
  }

  const updatedHTML = parseAVHtmlData(content?.text_body);

  console.log(content?.text_body, "AAAA", updatedHTML);

  return (
    <Card
      sx={{
        my: 1,
        width: "100%",
        height: "100%",
        backgroundColor: content.inner_color,
        p: 1.2,
        pt: 1,
        position: "relative",
        // overflow: 'visible',
        border: `1px solid ${content.color}`,
      }}
    >
      {showMenu ? (
        <div
          style={{
            position: "absolute",
            right: content.isPinned ? "33%" : "38%",
            top: 40,
            zIndex: 99,
          }}
          ref={iconMenuRef}
        >
          <IconMenu
            isEditable={showEditIcon}
            toggleMenu={() => setShowMenu((prevState) => !prevState)}
            // onEdit={() => nav(`/EditCustomWheel/${wheelId}/${content?.id}`)}
          ></IconMenu>
        </div>
      ) : null}
      <Stack
        sx={{ mb: 1, display: "flex", flex: 1 }}
        justifyContent={"space-between"}
        direction={"row"}
      >
        <Typography
          sx={{
            color: "#123051",
            fontFamily: "DM Sans",
            fontWeight: "bold",
            fontSize: "14px",
            textTransform: "capitalize",
            flex: 1,
            flexGrow: 1,
            minWidth: 0,
            textWrap: "wrap",
            whiteSpace: "normal",
            wordWrap: "break-word",
          }}
        >
          {content.title}
        </Typography>
        <Stack alignItems={"center"} direction={"row"}>
          {showEditIcon ? (
            <img
              ref={menuRef}
              onClick={() => setShowMenu((prevState) => !prevState)}
              style={{ marginRight: 5, cursor: "pointer" }}
              src={ASSETS.miniMenu}
              className="img-fluid"
              width="20"
              height="20"
              alt="cross"
              color={content.color}
            />
          ) : null}
          <Stack
            onClick={() => {
              content.isPinned ? onUnPin(content) : onPin(content);
            }}
            direction={"row-reverse"}
            sx={{
              px: 1,
              backgroundColor: content.isPinned ? "#123051" : "#FFFFFF",
              borderRadius: 5,
              gap: 1,
              mx: 1,
            }}
          >
            <TextView
              style={{
                cursor: "pointer",
                color: content.isPinned ? "white" : "#123051",
                fontFamily: "DM Sans",
                fontWeight: "700",
                fontSize: 12,
              }}
            >
              {content.isPinned ? "Pinned" : "Unpinned"}
            </TextView>
            <img
              style={{ cursor: "pointer" }}
              // onClick={() => onUnPin(content)}
              src={content.isPinned ? ASSETS.PinnedIcon : ASSETS.UnPinnedIcon}
              className="img-fluid"
              width="10"
              height="10"
              alt="cross"
              color={content.color}
            />
          </Stack>
          {/* {content?.isPinned ? (
           
          ) : (
            // <TextView
            //   style={{ marginRight: "5px", cursor: "pointer" }}
            //   onClick={() => onPin(content)}
            // >
            //   Pin
            // </TextView>
            <img
              onClick={() => onPin(content)}
              style={{ marginRight: "5px", cursor: "pointer" }}
              src={ASSETS.PinnedIcon}
              className="img-fluid"
              width="20"
              height="20"
              alt="cross"
              color={content.color}
            />
          )} */}

          <div
            onClick={() => {
              onCardClose(content);
            }}
            style={{
              // position: "absolute",
              // top: 0,
              // right: 10,
              // zIndex: 999,
              backgroundColor: content.color,
              border: "0.5px solid grey",
              width: "20px",
              height: "20px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
            }}
            class="rounded-circle"
          >
            <img
              src={ASSETS.crossIcon}
              className="img-fluid"
              width="10"
              height="10"
              alt="cross"
              color={content.color}
            />
          </div>
        </Stack>
      </Stack>

      <Stack sx={{ height: "100%" }} direction={"column"}>
        <Box
          sx={{
            width: "350px",
            height: "73vh",
            backgroundColor: "white",
            borderRadius: 2,
            pb: 1,
            // overflowY: "auto",
          }}
        >
          {/* <div
            style={{ lineHeight: 1, padding: 10 }}
            dangerouslySetInnerHTML={{ __html: updatedHTML }}
          /> */}
          <RichTextEditorViewWheel
            // value={content?.text_body}
            value={updatedHTML}
            id={position == "left" ? 1 : 2}
          />
        </Box>
      </Stack>
    </Card>
  );
};

const CardContainer = ({
  position = "left" || "right",
  topContent = null,
  bottomContent = null, //ignore
  onCardClose = () => {},
  hasTwoItems = true,
  wheelId,
  showEditIcon = false,

  onCardPin = () => {},
  onCardUnPin = () => {},
}) => {
  const [openPreviewImage, setOpenPreviewImage] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const handleOpenPreviewImage = (src) => {
    setSelectedImage(src);
    setOpenPreviewImage(true);
  };

  const handleClosePreviewImage = () => {
    setOpenPreviewImage(false);
  };
  console.log(
    document.querySelectorAll(".custom-image-class-for-click"),
    "Ddddd"
  );

  const [imagesUpdated, setImagesUpdated] = useState([]);

  // useEffect(() => {
  //   const images = document.querySelectorAll(".custom-image-class-for-click");

  //   // Define the click handler function
  //   const handleClick = (event) => {
  //     // alert("A");
  //     // setOpenPreviewImage(true);
  //     handleOpenPreviewImage(event.target.src);
  //   };

  //   // Add the event listener to each image
  //   images.forEach((img) => {
  //     img.addEventListener("click", handleClick);
  //   });

  //   // Clean up the event listeners when the component unmounts
  //   return () => {
  //     images.forEach((img) => {
  //       img.removeEventListener("click", handleClick);
  //     });
  //   };
  // }, [imagesUpdated]);

  useEffect(() => {
    const images = document.querySelectorAll(".custom-image-class-for-click");
    images.forEach((img) => {
      img.addEventListener("click", () => {
        // alert("A");
        setOpenPreviewImage(true);
        handleOpenPreviewImage(img.src);
      });
    });

    // Optional: Clean up the event listeners when the component unmounts
    return () => {
      images.forEach((img) => {
        img.removeEventListener("click", () => {
          // alert("A");
          setOpenPreviewImage(true);
          handleOpenPreviewImage(img.src);
        });
      });
    };
  }, [topContent, bottomContent, position]);

  if (!topContent && !bottomContent) {
    return null;
  }

  return (
    <Container
      style={{ padding: 0 }}
      sx={[
        {
          p: 0,
          width: "370px",
          position: "absolute",
          zIndex: 20,
        },
        position === "left" ? { left: 50 } : { right: 50 },
      ]}
    >
      <ImagePreviewModal
        openPreviewImage={openPreviewImage}
        handleClosePreviewImage={handleClosePreviewImage}
        selectedImage={selectedImage}
      />
      <Stack sx={{ height: "100%" }} direction={"column"}>
        {topContent && (
          <>
            <CardContent
              wheelId={wheelId}
              onCardClose={onCardClose}
              content={topContent}
              showEditIcon={showEditIcon}
              position={position}
              onPin={onCardPin}
              onUnPin={onCardUnPin}
            ></CardContent>
          </>
        )}
        {/* {bottomContent && (
          <>
            <CardContent
              wheelId={wheelId}
              onCardClose={onCardClose}
              content={bottomContent}
              showEditIcon={showEditIcon}
              position={position}
              onPin={onCardPin}
              onUnPin={onCardUnPin}
            ></CardContent>
          </>
        )} */}
      </Stack>
    </Container>
  );
};

export default CardContainer;
